var _path, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.731 12.8802C34.9502 14.0433 33.9624 15.079 32.8152 15.9075C32.8311 16.1465 32.8311 16.4014 32.8311 16.6564C32.8311 24.384 26.9517 33.2907 16.2127 33.2907C12.9145 33.2907 9.83943 32.3187 7.24231 30.6617C7.70437 30.7095 8.16644 30.7414 8.64444 30.7414C11.385 30.7414 13.9024 29.8013 15.8941 28.2398C14.6757 28.2146 13.4957 27.8095 12.5187 27.0811C11.5418 26.3527 10.8168 25.3373 10.4449 24.1768C10.7954 24.2406 11.1619 24.2884 11.5443 24.2884C12.0701 24.2884 12.5959 24.2087 13.0739 24.0812C11.7524 23.81 10.5648 23.0913 9.71152 22.0464C8.85819 21.0015 8.39127 19.6943 8.3895 18.3453V18.2815C9.18617 18.7117 10.0784 18.9826 11.0344 19.0145C10.2343 18.4777 9.5787 17.7521 9.12571 16.9017C8.67273 16.0513 8.43629 15.1024 8.4373 14.1389C8.4373 13.0714 8.7241 12.0676 9.23397 11.2072C12.1179 14.7444 16.4199 17.0706 21.2795 17.3096C21.1839 16.8794 21.1202 16.4333 21.1202 15.9712C21.1244 14.4231 21.7423 12.9399 22.8385 11.8467C23.9347 10.7535 25.4196 10.1396 26.9677 10.1396C28.6566 10.1396 30.1703 10.8407 31.2378 11.9879C32.5603 11.717 33.819 11.239 34.9502 10.5698C34.5041 11.9242 33.58 13.0714 32.3691 13.7884C33.5299 13.6615 34.6641 13.3551 35.731 12.8802Z",
    fill: "url(#paint0_linear_43_4122)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.0898,
    cy: 21.0898,
    r: 20.3366,
    stroke: "#4E3BE4",
    strokeWidth: 1.50642
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_4122",
    x1: 7.69995,
    y1: 10,
    x2: 21.4866,
    y2: 33.2907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.116573,
    stopColor: "#4B3BE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A36EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0871ef7790688cf4589970e6dabb1e8f.svg";
export { ForwardRef as ReactComponent };